import { OutOfOfficeMessage, AwayOutsideWorkingHoursMessage, AwayMessage, AvailableMessage, InactiveMessage } from './AgentAvailabilityMessage';
import { isHumanAgent } from '../operators/assignees';
import { jsx as _jsx } from "react/jsx-runtime";
export const AgentAvailabilityStatusMessage = ({
  agent,
  messageType
}) => {
  switch (messageType) {
    case 'OUT_OF_OFFICE':
      return agent && isHumanAgent(agent) ? /*#__PURE__*/_jsx(OutOfOfficeMessage, {
        agent: agent
      }) : null;
    case 'AWAY_OUTSIDE_WH':
      return /*#__PURE__*/_jsx(AwayOutsideWorkingHoursMessage, {});
    case 'AWAY':
      return /*#__PURE__*/_jsx(AwayMessage, {});
    case 'AVAILABLE':
      return /*#__PURE__*/_jsx(AvailableMessage, {});
    case 'INACTIVE':
      return /*#__PURE__*/_jsx(InactiveMessage, {});
    default:
      return null;
  }
};
AgentAvailabilityStatusMessage.displayName = 'AgentAvailabilityStatusMessage';